"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUpdateDeliveryChannelErrorResponse = exports.UpdateDeliveryChannelFailedEvent = exports.Name = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'update-delivery-channel-failed';
const UpdateDeliveryChannelFailedEvent = exports.UpdateDeliveryChannelFailedEvent = Name;
const isUpdateDeliveryChannelErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isUpdateDeliveryChannelErrorResponse = isUpdateDeliveryChannelErrorResponse;
//# sourceMappingURL=index.js.map